import Route from 'mewe/routes/route';
import { Theme } from 'mewe/constants';

export default Route.extend({
  theme: Theme.PAGE,

  model() {
    const model = this.modelFor('app.publicid');

    model.activeTab = 1;
    model.albumName = null;

    return model;
  },
});
